module.exports = __webpack_public_path__ + "img/polygon.2ddb887c.png";